


































































































import { Vue, Component } from 'vue-property-decorator'
import { setToken } from '@/helpers/token'

@Component
export default class Sign extends Vue {
	state = 'sign'
	login = ''
	signError = ''
	password = ''
	forgotEmail = ''
	loading = false

	created() {
		// If flag hard exist - mean hard logout user.
		// Display error message and remove the querystring
		if (this.$route.query.hard) {
			this.signError = 'error.Account deactivated'
			this.$router.replace(this.$route.path)
		}
	}

	signIn() {
		this.loading = true
		this.signError = ''
		this.axios({
			method: 'post',
			url: 'users/user/auth',
			data: {
				username: this.login,
				password: this.password,
			},
		})
			.then(response => {
				setToken(response.data.token)
				this.axios({
					method: 'get',
					url: 'users/user/me',
				}).then(response => {
					window.localStorage.setItem(
						'userProfile',
						JSON.stringify(response.data)
					)
					this.$router.push({ name: 'Recovery page' })
					window.location.reload()

					this.loading = false
				})

				window.localStorage.removeItem('savedActiveItems')
			})
			.catch(() => {
				this.loading = false

				this.signError = 'Password or login is not correct'
			})
	}

	restorePassword() {
		this.loading = true
		this.axios({
			method: 'post',
			url: 'users/user/restore',
			data: {
				email: this.forgotEmail,
			},
		})
			.then(response => {
				this.state = 'sent'
				this.loading = false
			})
			.catch(() => {
				this.loading = false
			})
	}
}
